// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

export const buildTourMemberRemoveMessage = (tourId: string, requestId: string, playerId: string) => ({
  type: 'tour.member.remove' as const,
  tourId,
  requestId,
  playerId,
});

export const buildRoundMemberRemoveMessage = (roundId: string, requestId: string, playerId: string) => ({
  type: 'round.member.remove' as const,
  roundId,
  requestId,
  playerId,
});

export const buildRoundRemoveMessage = (roundId: string, requestId: string) => ({
  type: 'round.remove' as const,
  roundId,
  requestId,
});

export const buildRoundMemberAddMessage = (roundId: string, requestId: string, playerId: string) => ({
  type: 'round.member.add' as const,
  roundId,
  requestId,
  playerId,
});

export const buildRoundGroupsSwapMessage = (roundId: string, requestId: string, playerIdA: string, playerIdB: string) => ({
  type: 'round.groups.swap' as const,
  roundId,
  requestId,
  playerIdA,
  playerIdB,
});

export const resolveMemberRemoveRejectedMessage = (
  t: (key: string) => string,
  fallbackKey: string,
  messageKey?: string,
  code?: string,
  message?: string
) => {
  const key = messageKey ?? code;
  if (key) {
    const translated = t(key);
    if (translated !== key) {
      return translated;
    }
  }

  if (message) {
    return message;
  }

  return t(fallbackKey);
};
